import styles from '@/styles/category/category-filter.module.scss'
import { useState } from 'react'
import Link from 'next/link'
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import GoogleADSense from '../GoogleADSense';

// 定义分类项接口
interface cateFilterItem {
  name: string;
  categoryID: number | string;
  parent: number;
  url: string;
  count: number | string;
  isSelected?: boolean;
  isExpand?: boolean;
  subCategories: cateFilterItem[];
}

interface cateFilterDataItem {
  title: string;
  key: string;
  items: cateFilterItem[];
}

interface Props {
  cateFilterData: cateFilterDataItem[]
}

export default function CategoryFilter({ cateFilterData }: Props) {
  const [cateData, setCateData] = useState<cateFilterDataItem[]>(JSON.parse(JSON.stringify(cateFilterData)));

  // 切换是否展示更多
  const toggleShowMore = (categoryId: number | string) => {
    let data = JSON.parse(JSON.stringify(cateData))

    data.forEach((item: cateFilterDataItem) => {
      item.items.forEach((cateFirstLevel: cateFilterItem) => {
        cateFirstLevel.subCategories.forEach((cateSecondLevel: cateFilterItem) => {
          if (cateSecondLevel.categoryID == categoryId) {
            cateSecondLevel.isExpand = !cateSecondLevel.isExpand
          }
        })
      })
    })

    setCateData(data)
  };

  return (
    <div className={styles['comp-category-filter']}>
      {
        cateData.map((item: cateFilterDataItem, index: number) => (
          <div className={styles['filter-title']} key={item.key}>
            {item.title}

            {/* 一级分类 */}
            {
              item.items.map((cateFirstLevel: cateFilterItem) => (
                <div className={styles['category-first-level']} key={index}>
                  <Link
                    href={cateFirstLevel.url}
                    legacyBehavior
                    passHref
                  >
                    <a rel="noopener noreferrer" title={cateFirstLevel.name}>
                      <div className={styles['first-level']}>
                        <div 
                          className={`
                            ${styles['first-level-name']}
                            ${cateFirstLevel.isSelected ? styles['selected'] : ''}
                          `}
                        >{cateFirstLevel.name}</div>
                        <div className={styles['first-level-count']}>&nbsp;({cateFirstLevel.count})</div>
                      </div>
                    </a>
                  </Link>

                  {/* 二级分类 */}
                  {
                    !!(cateFirstLevel.subCategories && cateFirstLevel.subCategories.length) &&
                    cateFirstLevel.subCategories.map((cateSecondLevel: cateFilterItem) => (
                      <div className={styles['second-level']} key={cateSecondLevel.categoryID}>
                        <div 
                          className={styles['second-level-box']}
                          style={ cateSecondLevel.subCategories && cateSecondLevel.subCategories.length ? undefined : { paddingLeft: '16px' } }
                        >
                          {
                            !!(cateSecondLevel.subCategories && cateSecondLevel.subCategories.length) &&
                            <div
                              className={styles['fold-box']}
                              onClick={() => { toggleShowMore(cateSecondLevel.categoryID) }}
                            >
                              {
                                cateSecondLevel.isExpand ?
                                <CaretUpOutlined style={{ fontSize: '12px', color: '#333333' }}></CaretUpOutlined>
                                :
                                <CaretDownOutlined style={{ fontSize: '12px', color: '#999999' }}></CaretDownOutlined>
                              }
                            </div>
                          }
                          
                          <Link
                            href={cateSecondLevel.url}
                            legacyBehavior
                            passHref
                          >
                            <a 
                              style={{ display: 'block', width: '100%', paddingRight: '16px' }} 
                              title={cateSecondLevel.name}
                              rel="noopener noreferrer"
                            >
                              <div className={styles['second-level-name-box']}>
                                <div
                                  className={`
                                    ${styles['second-level-name-text']} 
                                    ${cateSecondLevel.isExpand ? styles['expand'] : ''} 
                                    ${cateSecondLevel.isSelected ? styles['selected'] : ''}
                                  `}
                                >{cateSecondLevel.name}</div>
                                <div className={styles['second-level-count']}>&nbsp;({cateSecondLevel.count})</div>
                              </div>
                            </a>
                          </Link>
                        </div>

                        {/* 三级分类 */}
                        {
                          !!(cateSecondLevel.isExpand) &&
                          <div className={styles['third-level-box']}>
                            {
                              cateSecondLevel.subCategories.map((cateThirdLevel: cateFilterItem) => (
                                <Link
                                  href={cateThirdLevel.url}
                                  key={cateThirdLevel.categoryID}
                                  legacyBehavior
                                  passHref
                                >
                                  <a 
                                    className={styles['third-level']}
                                    title={cateThirdLevel.name}
                                    rel="noopener noreferrer">
                                    <div 
                                      className={`
                                        ${styles['third-level-name']}
                                        ${cateThirdLevel.isSelected ? styles['selected'] : ''}
                                      `}
                                    >{cateThirdLevel.name}</div>
                                    <div className={styles['third-level-count']}>&nbsp;({cateThirdLevel.count})</div>
                                  </a>
                                </Link>   
                              ))
                            }
                          </div>
                        }
                      </div>
                    ))
                  }
                </div>
              ))
            }
          </div>
        ))
      }
      <GoogleADSense />
    </div>
  )
}